<template>
    <div>
        <b-modal class="full-image" header-class="d-none" centered footer-class="d-none"
            content-class="custom-model-wrap overflow-hidden text-center" title-class="" v-model="showImage">
            <template #default="{ cancel }">
                <button class="close test-close-btn" variant="none" @click="cancel">x</button>
                <b-img rounded class="border pointer-event show-image" :src="image"></b-img>
            </template>
        </b-modal>
        <!-- <b-img rounded class="border" @click="uploadBtnClick" width="100" :src="image ? image : defaultProfile"></b-img> -->
        <div class="position-relative d-inline-block">
            <b-img 
                 
                class="border-circle" 
                @click="uploadBtnClick" 
                width="120" 
                :src="image ? image : defaultProfile" 
                alt="Profile Image"
            ></b-img>
            <div 
                class="upload-icon position-absolute border-circle"
                @click="uploadBtnClick"
                title="Upload Image"
            >
                <i class="mdi mdi-pencil"></i>
            </div>
        </div>
        
        
        <!-- <b-input-group>
           
            <b-form-input disabled :value="fileName"></b-form-input>
            <b-img :src="documentUrl" fluid alt="Uploaded Image" width="80" height="80"></b-img>
             <i v-else-if="['pdf'].includes(fileName && fileName.split('.').pop())" class="fa fa-file-pdf fa-2x"></i>
            <i v-else-if="['xls', 'xlsx'].includes(fileName && fileName.split('.').pop())" class="fa fa-file-excel fa-2x"></i> 
            <div class="d-flex gap-2 ms-2">
                <b-button class="test-link-modal-cloud-btn" v-if="!image" :title="$translate('download')" :href="documentUrl" target="_blank"
                    :class="{ 'me-0': disabled }" :disabled="!value">
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                </b-button>
              
                <b-button class="test-link-modal-cloud-upload-btn" v-if="!disabled" @click="uploadBtnClick" variant="info">
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </div>
        </b-input-group> -->

        <b-modal :id="uploadKey" header-class="p-0" footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap" title-class="p-2" v-model="is_visible" :title="$translate('upload_file')">
            <b-tabs card align="center" v-model="tabIdx">
                <b-tab :title="$translate('upload_image')">
                    <b-overlay :show="!loaded" rounded="sm">
                        <b-form-file id="uploadData" :placeholder="$translate('no_file_chosen')" ref="uploadData"
                            @change="uploadFile"></b-form-file>
                    </b-overlay>

                </b-tab>

                <b-tab :title="$translate('add_link')">
                    <b-overlay :show="!loaded" rounded="sm">
                        <b-col md="12" cols="12">
                            <label class="mb-3 mt-3" label-for="input-url">
                                <strong>{{ $translate('profile_pic') }}</strong>
                            </label>
                            <b-input-group>
                                <b-form-input id="input-url" type="text" v-model="imageUrl"
                                    :placeholder="$translate('enter_image_url')" />
                                <b-input-group-append>
                                    <b-button variant="blue-button" @click="fetchAndUploadImage">
                                        {{ $translate('upload_image') }}
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-overlay>
                </b-tab>
            </b-tabs>
            <template #modal-footer="{ cancel }">
                <div class="d-flex">
                    <!-- <b-button vatiant="blue-button" size="fw" @click="ok">Ok</b-button> -->
                    <b-button class="test-close-label-btn" vatiant="blue-button" :disabled="!loaded" size="fw"
                        @click="cancel">{{ $cancelLabel()
                        }}</b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import defaultProfile from "@/assets/images/faces/face1.jpg"
export default {
    mixins: [popupMixins],
    data() {
        return {
            key: null,
            fileName: null,
            is_visible: false,
            uploadKey: 0,
            loaded: true,
            showImage: false,
            uploadedObjectURL: null,
            tabIdx: 0,
            imageUrl: '',
            image : "",
            defaultProfile: defaultProfile,
        }
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
      
    },
    computed: {
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
        documentUrl() {
            return `${this.mediaBaseUrl}/${this.key}`
        },
        uploadedImageUrl() {
            if (this.key) {
                return URL.createObjectURL(new File([], this.fileName)); // You may need to replace the empty array with the correct file information
            }
            return null;
        },
    },
    watch: {
        is_visible: function (val) {
            console.log('is_visible', val)
            if (!val) this.key = this.value
        },
        value: {
            immediate: true,
            handler: function (val) {
                this.convertValue(val)
            }
        },
    },
    created() {
        this.uploadKey =
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
    },
    mounted() {
        this.convertValue(this.value)
    },
    methods: {
        convertValue(value) {
            try {
                const obj = JSON.parse(value)
                this.key = obj.key
                this.fileName = obj.name
            } catch (err) {
                this.key = value
                this.fileName = value
            }
        },
        nextTick() {
            return new Promise(resolve => {
                this.$nextTick(() => resolve())
            })
        },
        uploadBtnClick() {
            this.is_visible = true
            this.$emit('upload-btn-clicked', 1)
        },
        async uploadFile(event) {
            this.loaded = !this.loaded
            try {
                let allowedTypes = this.$allowedTypes
                var fileName = event.target.files[0].name;
                var fileExtension = fileName.split('.').pop();
                let maxFileSize = this.$maxFileSize
                if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                    this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                    this.loaded = !this.loaded
                    return false;
                }
                if (maxFileSize < event.target.files[0].size) {
                    this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                    return false
                }
                const img = new Image();
                this.uploadedObjectURL = URL.createObjectURL(event.target.files[0]);
                img.src = this.uploadedObjectURL
                console.log('uploadFile:', event.target.files);
                await this.$store.dispatch('js_report/fetchCredentials')
                await this.nextTick()
                const { key, name } = await this.$store.dispatch(
                    's3files/s3singleUpload',
                    event.target.files
                )
                console.log('uploadFile: BINGO')
                this.key = key
                this.fileName = name
                await this.nextTick()
                const url = this.documentUrl
                this.image = url;
                const obj = { key, name, url }
                this.$emit('input', JSON.stringify(obj))
                this.is_visible = false
                this.doToast(this.$translate('success'), this.$translate('upload_image_success'), 'success')
                this.loaded = !this.loaded

            } catch (err) {
                this.loaded = !this.loaded
                this.doToast(this.$translate('error'), err.message, 'danger')
            }
        },
        async fetchAndUploadImage() {
            this.loaded = !this.loaded;
            try {
                if (!this.imageUrl) {
                    this.doToast(this.$translate('error'), this.$translate('invalid_url'), 'danger');
                    this.loaded = !this.loaded;
                    return false;
                }

                const response = await fetch(this.imageUrl);
                const blob = await response.blob();
                const fileName = this.imageUrl.split('/').pop();

                let allowedTypes = this.$allowedTypes;
                let fileExtension = fileName.split('.').pop();

                if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                    this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger');
                    this.loaded = !this.loaded;
                    return false;
                }

                let maxFileSize = this.$maxFileSize;
                if (maxFileSize < blob.size) {
                    this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger');
                    this.loaded = !this.loaded;
                    return false;
                }

                // Convert Blob to a format compatible with s3singleUpload
                const file = new File([blob], fileName, { type: blob.type });

                // Fetch AWS credentials
                await this.$store.dispatch('js_report/fetchCredentials');
                await this.$nextTick();

                // Upload Blob to S3 using s3singleUpload action
                const { key, name } = await this.$store.dispatch('s3files/s3singleUploadurl', file);

                // Handle successful upload
                this.key = key;
                this.fileName = name;
                await this.nextTick()
                const url = this.documentUrl;
                this.image = url;
                const obj = { key, name, url };
                this.$emit('input', JSON.stringify(obj));
                this.is_visible = false;
                this.doToast(this.$translate('success'), this.$translate('upload_image_success'), 'success');
                this.loaded = !this.loaded;

            } catch (err) {
                // Handle error
                this.loaded = !this.loaded;
                this.doToast(this.$translate('error'), err.message, 'danger');
            }
        },

    },
}
</script>
<style scoped>

/* Circle border for the image */
.border-circle {
    border-radius: 50%; /* Makes the image border circular */
    border: 2px solid #ccc; /* Optional: Add a border around the image */
}

/* Pen Icon Styling */
.upload-icon {
    bottom: 4px; /* Adjust to position slightly above the edge */
    right: 4px; /* Adjust to position slightly to the left of the edge */
    width: 30px; /* Circle size for the pen icon */
    height: 30px;
    background-color: #007bff; /* Background color for the pen icon */
    color: #fff; /* Icon color */
    border: 2px solid #fff; /* White border around the pen */
    border-radius: 50%; /* Circle shape */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 18px
}
</style>